import { render, staticRenderFns } from "./IngressTopo.vue?vue&type=template&id=ef7ff72a&scoped=true&"
import script from "./IngressTopo.vue?vue&type=script&lang=js&"
export * from "./IngressTopo.vue?vue&type=script&lang=js&"
import style0 from "./IngressTopo.vue?vue&type=style&index=0&id=ef7ff72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7ff72a",
  null
  
)

export default component.exports